import { TranslationKeys } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type HomeDataSectionTotalProps = {
  label: TranslationKeys;
  value: number;
};

export const HomeDataSectionTotal: FC<HomeDataSectionTotalProps> = ({ label, value }) => {
  const { t } = useTranslation();

  return (
    <div className='grid place-items-baseline gap-0.5 px-5 font-semibold'>
      <h4 className='capitalize text-primary-900'>{t(label as any)}</h4>
      <p className='text-3xl text-brand-600'>{value != null ? value.toLocaleString() : '0'}</p>
    </div>
  );
};
